import axios from 'axios';

const SchoolStaff = {
    namespaced: true,
    state: {
        schoolStaff: JSON.stringify(localStorage.getItem('#####')),
    },
    mutations: {
        Save_School_Staff_Info(state, payload) {
            localStorage.setItem('#####', payload)
            state.schoolStaff = payload
        },
        Clear_School_Staff_Info(state) {
            localStorage.removeItem('#####');
            state.schoolStaff = null;
        },
    },
    getters: {
        _schoolStaff: state => state.schoolStaff,
    },
    actions: {
        CreateSchoolStaff({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/CreateSchoolStaff`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        UpdateSchoolStaff({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/UpdateSchoolStaff`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        DeleteSchoolStaff({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/DeleteSchoolStaff`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateClassTeacher({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/CreateClassTeacher`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateSubjectTeacher({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/CreateSubjectTeacher`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStaffById({ rootState }, StaffId) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/GetStaffById?StaffId=${StaffId}`, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetSchoolStaffs({ rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/GetSchoolStaffs`, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetSchoolStaffAll({ rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/GetSchoolStaffAll`, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetSchoolStaffsDeleted({ rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/GetSchoolStaffsDeleted`, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetLoginStaffDetails({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.get(`${process.env.VUE_APP_ENV_API_URL}PortalSchoolStaff/GetLoginStaffDetails`, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        const data = returnData.data;
                        commit('Save_School_Staff_Info', data)
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
    },
}

export default SchoolStaff
